/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Balancing_Display_No_GroupingInputs */



/**
* | output |
* | --- |
* | "Do not group" |
*
* @param {Manual_Balancing_Display_No_GroupingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const manual_balancing_display_no_grouping = /** @type {((inputs?: Manual_Balancing_Display_No_GroupingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Balancing_Display_No_GroupingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Do not group")
	return /** @type {LocalizedString} */ ("Ne pas grouper")
});